/**
 * Do not edit directly
 * Generated on Tue, 09 Nov 2021 15:03:09 GMT
 */

export const ColorA0 = "#FFFDFB";
export const ColorA25 = "#FFF9F5";
export const ColorA50 = "#FFF5EC";
export const ColorA100 = "#FFF0E2";
export const ColorA150 = "#FFE1C5";
export const ColorA200 = "#FFD7B2";
export const ColorA250 = "#FFCD9F";
export const ColorA300 = "#FFC38B";
export const ColorA350 = "#FFB978";
export const ColorA400 = "#FFAF65";
export const ColorA450 = "#FFA552";
export const ColorA500 = "#FF9B3F";
export const ColorA550 = "#E58B38";
export const ColorA600 = "#CC7C32";
export const ColorA650 = "#B26C2B";
export const ColorA700 = "#995D25";
export const ColorA750 = "#7F4D1F";
export const ColorA800 = "#663E19";
export const ColorA850 = "#4C2E12";
export const ColorA900 = "#331F0C";
export const ColorA950 = "#190F06";
export const ColorA975 = "#0D0703";
export const ColorA1000 = "#050301";
export const ColorBlack = "#05051E";
export const ColorGray = "#60607D";
export const ColorGrey = "#60607D";
export const ColorNeutral = "#AEAEBC";
export const ColorWhite = "#FFFFFF";
export const ColorAmber = "#FF9B3F";
export const ColorRed = "#DC2F23";
export const ColorOrange = "#F97316";
export const ColorBlue = "#076CDF";
export const ColorFuchsia = "#A32DC1";
export const ColorGreen = "#3ED483";
export const ColorPurple = "#5B19C4";
export const ColorYellow = "#FFEB72";
export const ColorLime = "#A3E635";
export const ColorTurquoise = "#00CACF";
export const ColorRose = "#F43F5E";
export const ColorPink = "#EC4899";
export const ColorB0 = "#FAFCFE";
export const ColorB25 = "#F2F7FD";
export const ColorB50 = "#E6F0FB";
export const ColorB100 = "#CDE1F8";
export const ColorB150 = "#B5D3F5";
export const ColorB200 = "#9BC4F2";
export const ColorB250 = "#83B5EF";
export const ColorB300 = "#6AA6EB";
export const ColorB350 = "#5198E8";
export const ColorB400 = "#3889E5";
export const ColorB450 = "#207AE2";
export const ColorB500 = "#076CDF";
export const ColorB550 = "#0660C8";
export const ColorB600 = "#0556B2";
export const ColorB650 = "#044B9B";
export const ColorB700 = "#044085";
export const ColorB750 = "#03356F";
export const ColorB800 = "#022B59";
export const ColorB850 = "#022042";
export const ColorB900 = "#01152C";
export const ColorB950 = "#000A15";
export const ColorB975 = "#00050B";
export const ColorB1000 = "#000204";
export const ColorF0 = "#FDFAFD";
export const ColorF25 = "#FAF4FB";
export const ColorF50 = "#F5EAF8";
export const ColorF100 = "#ECD5F2";
export const ColorF150 = "#E3C0EC";
export const ColorF200 = "#DAABE6";
export const ColorF250 = "#D196E0";
export const ColorF300 = "#C781D9";
export const ColorF350 = "#BE6CD3";
export const ColorF400 = "#B557CD";
export const ColorF450 = "#AC42C7";
export const ColorF500 = "#A32DC1";
export const ColorF550 = "#9228AD";
export const ColorF600 = "#82249A";
export const ColorF650 = "#711F86";
export const ColorF700 = "#611B73";
export const ColorF750 = "#511660";
export const ColorF800 = "#41124D";
export const ColorF850 = "#300D39";
export const ColorF900 = "#200926";
export const ColorF950 = "#0F0412";
export const ColorF975 = "#080209";
export const ColorF1000 = "#030003";
export const ColorG0 = "#FBFEFC";
export const ColorG25 = "#F5FCF8";
export const ColorG50 = "#ECFAF2";
export const ColorG100 = "#D8F6E6";
export const ColorG150 = "#C5F2DA";
export const ColorG200 = "#B1EDCD";
export const ColorG250 = "#9EE9C1";
export const ColorG300 = "#8BE5B4";
export const ColorG350 = "#78E0A8";
export const ColorG400 = "#64DC9B";
export const ColorG450 = "#51D88F";
export const ColorG500 = "#3ED483";
export const ColorG550 = "#37BE75";
export const ColorG600 = "#31A968";
export const ColorG650 = "#2B935B";
export const ColorG700 = "#257F4E";
export const ColorG750 = "#1E6941";
export const ColorG800 = "#185434";
export const ColorG850 = "#123F27";
export const ColorG900 = "#0C2A1A";
export const ColorG950 = "#06140C";
export const ColorG975 = "#030A06";
export const ColorG1000 = "#010402";
export const ColorL0 = "#FDFEFB";
export const ColorL25 = "#FAFDF4";
export const ColorL50 = "#F5FCEB";
export const ColorL100 = "#ECFAD6";
export const ColorL150 = "#E3F7C2";
export const ColorL200 = "#DAF5AE";
export const ColorL250 = "#D1F29A";
export const ColorL300 = "#C7F085";
export const ColorL350 = "#BEED71";
export const ColorL400 = "#B5EB5D";
export const ColorL450 = "#ACE849";
export const ColorL500 = "#A3E635";
export const ColorL550 = "#92CE2F";
export const ColorL600 = "#82B82A";
export const ColorL650 = "#71A024";
export const ColorL700 = "#618A1F";
export const ColorL750 = "#51721A";
export const ColorL800 = "#415C15";
export const ColorL850 = "#30440F";
export const ColorL900 = "#202E0A";
export const ColorL950 = "#0F1605";
export const ColorL975 = "#080B02";
export const ColorL1000 = "#030401";
export const ColorN0 = "#FFFFFF";
export const ColorN25 = "#FAFAFB";
export const ColorN50 = "#F7F7F8";
export const ColorN100 = "#EEEEF1";
export const ColorN150 = "#E5E5E9";
export const ColorN200 = "#DEDEE4";
export const ColorN250 = "#D6D6DD";
export const ColorN300 = "#CECED6";
export const ColorN350 = "#C6C6D0";
export const ColorN400 = "#BEBEC9";
export const ColorN450 = "#B6B6C2";
export const ColorN500 = "#AEAEBC";
export const ColorN550 = "#9F9FB1";
export const ColorN600 = "#9090A4";
export const ColorN650 = "#7F7F97";
export const ColorN700 = "#60607D";
export const ColorN750 = "#51516A";
export const ColorN800 = "#434357";
export const ColorN850 = "#343444";
export const ColorN900 = "#262632";
export const ColorN950 = "#1C1C25";
export const ColorN975 = "#131319";
export const ColorN1000 = "#05051E";
export const ColorO0 = "#FEFCFA";
export const ColorO25 = "#FEF7F3";
export const ColorO50 = "#FEF1E8";
export const ColorO100 = "#FDE3D0";
export const ColorO150 = "#FDD5B9";
export const ColorO200 = "#FCC7A1";
export const ColorO250 = "#FCB98A";
export const ColorO300 = "#FBAB73";
export const ColorO350 = "#FA9D5C";
export const ColorO400 = "#FA8F44";
export const ColorO450 = "#F9812D";
export const ColorO500 = "#F97316";
export const ColorO550 = "#DF6713";
export const ColorO600 = "#C75C11";
export const ColorO650 = "#AD500F";
export const ColorO700 = "#95450D";
export const ColorO750 = "#7C390A";
export const ColorO800 = "#632E08";
export const ColorO850 = "#4A2206";
export const ColorO900 = "#311704";
export const ColorO950 = "#180B02";
export const ColorO975 = "#0C0501";
export const ColorO1000 = "#040200";
export const ColorK0 = "#FEFBFD";
export const ColorK25 = "#FEF5F9";
export const ColorK50 = "#FDEDF5";
export const ColorK100 = "#FBDAEA";
export const ColorK150 = "#F9C8E0";
export const ColorK200 = "#F7B5D6";
export const ColorK250 = "#F5A3CC";
export const ColorK300 = "#F391C1";
export const ColorK350 = "#F17FB7";
export const ColorK400 = "#EF6CAD";
export const ColorK450 = "#ED5AA3";
export const ColorK500 = "#EC4899";
export const ColorK550 = "#D34089";
export const ColorK600 = "#BC397A";
export const ColorK650 = "#A4326A";
export const ColorK700 = "#8D2B5B";
export const ColorK750 = "#75234C";
export const ColorK800 = "#5E1C3D";
export const ColorK850 = "#46152D";
export const ColorK900 = "#200926";
export const ColorK950 = "#17070F";
export const ColorK975 = "#0C0307";
export const ColorK1000 = "#040103";
export const ColorP0 = "#FBFAFD";
export const ColorP25 = "#F6F3FB";
export const ColorP50 = "#EEE8F9";
export const ColorP100 = "#DED1F3";
export const ColorP150 = "#CEBAED";
export const ColorP200 = "#BDA3E7";
export const ColorP250 = "#AD8CE1";
export const ColorP300 = "#9C75DB";
export const ColorP350 = "#8C5ED5";
export const ColorP400 = "#7B47CF";
export const ColorP450 = "#6B30CA";
export const ColorP500 = "#5B19C4";
export const ColorP550 = "#5116B0";
export const ColorP600 = "#48149C";
export const ColorP650 = "#3F1188";
export const ColorP700 = "#360F75";
export const ColorP750 = "#2D0C61";
export const ColorP800 = "#240A4E";
export const ColorP850 = "#1B073A";
export const ColorP900 = "#120527";
export const ColorP950 = "#080213";
export const ColorP975 = "#040109";
export const ColorP1000 = "#010003";
export const ColorR0 = "#FEFAFA";
export const ColorR25 = "#FDF4F3";
export const ColorR50 = "#FBEAE9";
export const ColorR100 = "#F9E0DE";
export const ColorR150 = "F4C1BD";
export const ColorR200 = "#F1ABA7";
export const ColorR250 = "#ED9791";
export const ColorR300 = "#EA827B";
export const ColorR350 = "#E66D65";
export const ColorR400 = "#E3584F";
export const ColorR450 = "#DF4439";
export const ColorR500 = "#DC2F23";
export const ColorR550 = "#C52A1F";
export const ColorR600 = "#B0251C";
export const ColorR650 = "#992018";
export const ColorR700 = "#841C15";
export const ColorR750 = "#6D1711";
export const ColorR800 = "#58120E";
export const ColorR850 = "#410E0A";
export const ColorR900 = "#2C0907";
export const ColorR950 = "#150403";
export const ColorR975 = "#0B0201";
export const ColorR1000 = "#040000";
export const ColorE0 = "#FEFBFB";
export const ColorE25 = "#FEF5F6";
export const ColorE50 = "#FDECEF";
export const ColorE100 = "#FCD8DE";
export const ColorE150 = "#FBC5CF";
export const ColorE200 = "#FAB2BE";
export const ColorE250 = "#F99FAE";
export const ColorE300 = "#F88B9E";
export const ColorE350 = "#F7788E";
export const ColorE400 = "#F6657E";
export const ColorE450 = "#F5526E";
export const ColorE500 = "#F43F5E";
export const ColorE550 = "#DB3854";
export const ColorE600 = "#C3324B";
export const ColorE650 = "#AA2B41";
export const ColorE700 = "#922538";
export const ColorE750 = "#791F2E";
export const ColorE800 = "#611925";
export const ColorE850 = "#48121C";
export const ColorE900 = "#300C12";
export const ColorE950 = "#170609";
export const ColorE975 = "#0C0304";
export const ColorE1000 = "#040101";
export const ColorT0 = "#FAFDFE";
export const ColorT25 = "#F2FCFC";
export const ColorT50 = "#E6F9FA";
export const ColorT100 = "#CCF4F5";
export const ColorT150 = "#B3EFF0";
export const ColorT200 = "#99E9EB";
export const ColorT250 = "#80E4E7";
export const ColorT300 = "#66DFE2";
export const ColorT350 = "#4DDADD";
export const ColorT400 = "#33D4D8";
export const ColorT450 = "#1ACFD3";
export const ColorT500 = "#00CACF";
export const ColorT550 = "#00B5B9";
export const ColorT600 = "#00A1A5";
export const ColorT650 = "#008D90";
export const ColorT700 = "#00797C";
export const ColorT750 = "#006467";
export const ColorT800 = "#005052";
export const ColorT850 = "#003C3D";
export const ColorT900 = "#002829";
export const ColorT950 = "#001314";
export const ColorT975 = "#000A0A";
export const ColorT1000 = "#000304";
export const ColorY0 = "#FFFEFC";
export const ColorY25 = "#FFFDF7";
export const ColorY50 = "#FFFDF1";
export const ColorY100 = "#FFFBE2";
export const ColorY150 = "#FFF9D4";
export const ColorY200 = "#FFF7C6";
export const ColorY250 = "#FFF5B8";
export const ColorY300 = "#FFF3AA";
export const ColorY350 = "#FFF19C";
export const ColorY400 = "#FFEF8E";
export const ColorY450 = "#FFED80";
export const ColorY500 = "#FFEB72";
export const ColorY550 = "#E5D366";
export const ColorY600 = "#CCBC5B";
export const ColorY650 = "#B2A44F";
export const ColorY700 = "#998D44";
export const ColorY750 = "#7F7538";
export const ColorY800 = "#665E2D";
export const ColorY850 = "#4C4621";
export const ColorY900 = "#332F16";
export const ColorY950 = "#19170B";
export const ColorY975 = "#0D0B05";
export const ColorY1000 = "#050402";
export const MotionEasingStandard = "cubic-bezier(0.4, 0.14, 0.3, 1)";
export const MotionEasingEntrance = "cubic-bezier(0, 0, 0.3, 1)";
export const MotionEasingExit = "cubic-bezier(0.4, 0.14, 1, 1)";
export const MotionDurationFastest = "70ms";
export const MotionDurationFast = "110ms";
export const MotionDurationModerate = "240ms";
export const MotionDurationSlow = "400ms";
export const MotionDurationSlowest = "700ms";
export const Opacity0 = 0;
export const Opacity5 = 0.05;
export const Opacity10 = 0.1;
export const Opacity20 = 0.2;
export const Opacity25 = 0.25;
export const Opacity30 = 0.3;
export const Opacity40 = 0.4;
export const Opacity50 = 0.5;
export const Opacity60 = 0.6;
export const Opacity70 = 0.7;
export const Opacity80 = 0.8;
export const Opacity90 = 0.9;
export const Opacity95 = 0.95;
export const Opacity100 = 1;
export const Radius0 = "0"; // 0px
export const Radius2 = "0.125rem"; // 2px
export const Radius4 = "0.25rem"; // 4px
export const Radius6 = "0.375rem"; // 6px
export const Radius8 = "0.5rem"; // 8px
export const Radius12 = "0.75rem"; // 12px
export const Radius16 = "1rem"; // 16px
export const Radius24 = "1.5rem"; // 24px
export const RadiusRounded = "9999px"; // 9999px
export const ScreenXxsmall = "(max-width: 22.5em)"; // 0-360px
export const ScreenXsmall = "(max-width: 39.9375em)"; // 0-639px
export const ScreenSmall = "(min-width: 36em)"; // 640px and above
export const ScreenMedium = "(min-width: 48em)"; // 768px and above
export const ScreenLarge = "(min-width: 62em)"; // 1024px and above
export const ScreenXlarge = "(min-width: 75em)"; // 1280px and above
export const ScreenXxlarge = "(min-width: 100em)"; // 1600px and above
export const ScreenXxxlarge = "(min-width: 120em)"; // 1920px and above
export const Shadow1 = "0 0 1px 0 rgba(5,5,30,0.15)";
export const Shadow2 = "0 1px 2px 0 rgba(5,5,30,0.15)";
export const Shadow4 = "0 2px 4px 0 rgba(5,5,30,0.15)";
export const Shadow6 = "0 3px 6px 0 rgba(5,5,30,0.15)";
export const Shadow8 = "0 4px 8px 0 rgba(5,5,30,0.15)";
export const Shadow10 = "0 5px 10px 0 rgba(5,5,30,0.15)";
export const Shadow12 = "0 6px 12px 0 rgba(5,5,30,0.15)";
export const Shadow14 = "0 7px 14px 0 rgba(5,5,30,0.15)";
export const Shadow16 = "0 8px 16px 0 rgba(5,5,30,0.15)";
export const Shadow18 = "0 9px 18px 0 rgba(5,5,30,0.15)";
export const Shadow20 = "0 10px 20px 0 rgba(5,5,30,0.15)";
export const Shadow22 = "0 11px 22px 0 rgba(5,5,30,0.15)";
export const Shadow24 = "0 12px 24px 0 rgba(5,5,30,0.15)";
export const ShadowColor = "rgba(5,5,30,0.15)";
export const ShadowInner = "inset 0 0 1px 0 rgba(5,5,30,0.15)";
export const Spacing2 = "0.125rem"; // 2px
export const Spacing4 = "0.25rem"; // 4px
export const Spacing8 = "0.5rem"; // 8px
export const Spacing12 = "0.75rem"; // 12px
export const Spacing16 = "1rem"; // 16px
export const Spacing20 = "1.25rem"; // 20px
export const Spacing24 = "1.5rem"; // 24px
export const Spacing28 = "1.75rem"; // 28px
export const Spacing32 = "2rem"; // 32px
export const Spacing36 = "2.25rem"; // 36px
export const Spacing40 = "2.5rem"; // 40px
export const Spacing44 = "2.75rem"; // 44px
export const Spacing48 = "3rem"; // 48px
export const Spacing52 = "3.25rem"; // 52px
export const Spacing56 = "3.5rem"; // 56px
export const Spacing60 = "3.75rem"; // 60px
export const Spacing64 = "4rem"; // 64px
export const Spacing80 = "5rem"; // 80px
export const Spacing96 = "6rem"; // 96px
export const Spacing160 = "10rem"; // 160px
export const FontFamilySans = "Inter, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantrell, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const FontFamilySerif = "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Symbola', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const FontFamilyMono = "Menlo, 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const FontFamilyAr = "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"; // Arabic
export const FontFamilyJa = "Inter, '游ゴシック体', YuGothic, 'ヒラギノ丸ゴ', 'Hiragino Sans', 'Yu Gothic UI', 'Meiryo UI', 'MS Gothic', Roboto, Noto, 'Noto Sans CJK JP', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"; // Japanese
export const FontFamilyKo = "Inter, 'Nanum Gothic', 'Apple SD Gothic Neo', 'Malgun Gothic', Roboto, Noto, 'Noto Sans CJK KR', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"; // Korean
export const FontFamilyZhHant = "Inter, 'PingFang TC', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"; // Chinese (Traditional)
export const FontFamilyZhHans = "Inter, 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"; // Chinese (Simplified)
export const FontSize10 = "0.625rem"; // 10px
export const FontSize11 = "0.6875rem"; // 11px
export const FontSize12 = "0.75rem"; // 12px
export const FontSize13 = "0.8125rem"; // 13px
export const FontSize14 = "0.875rem"; // 14px
export const FontSize16 = "1rem"; // 16px
export const FontSize18 = "1.125rem"; // 18px
export const FontSize20 = "1.25rem"; // 20px
export const FontSize22 = "1.375rem"; // 22px
export const FontSize24 = "1.5rem"; // 24px
export const FontSize28 = "1.75rem"; // 28px
export const FontSize32 = "2rem"; // 32px
export const FontSize36 = "2.25rem"; // 36px
export const FontSize40 = "2.5rem"; // 40px
export const FontSize42 = "2.625rem"; // 42px
export const FontSize44 = "2.75rem"; // 44px
export const FontSize48 = "3rem"; // 48px
export const FontSize54 = "3.375rem"; // 54px
export const FontSize58 = "3.625rem"; // 58px
export const FontSize60 = "3.75rem"; // 60px
export const FontSize68 = "4.25rem"; // 68px
export const FontSize76 = "4.75rem"; // 76px
export const FontSize84 = "5.25rem"; // 84px
export const FontSize92 = "5.75rem"; // 92px
export const FontStyleRegular = "normal";
export const FontStyleItalic = "italic";
export const FontWeightThin = 100;
export const FontWeightExtralight = 200;
export const FontWeightLight = 300;
export const FontWeightRegular = 400;
export const FontWeightMedium = 500;
export const FontWeightSemibold = 600;
export const FontWeightBold = 700;
export const FontWeightExtrabold = 800;
export const FontWeightBlack = 900;
export const LeadingNone = "1";
export const LeadingTight = "1.25";
export const LeadingNormal = "1.5";
export const LeadingRelaxed = "1.75";
export const LeadingLoose = "2";
export const TrackingTighter = "-0.125ch";
export const TrackingTight = "-0.0625ch";
export const TrackingNormal = "0";
export const TrackingWide = "0.125ch";
export const TrackingWider = "0.25ch";
export const TrackingWidest = "0.5ch";